export default "/kiban/_next/static/images/awDataSupplied-00d1d9c8f7782a3f33ef4a9bde7dcf9c.png";